<template>
    <v-container fill-height>
        <v-layout  justify-center fill style="align-items: center; justify-content: center;">
            <v-card width="300"  style="background-color: whitesmoke; text-decoration-color: snow !important;">
                <v-card-title><v-layout justify-center class="headline mt-3" style="color: black;">Fitz Home - Login</v-layout></v-card-title>
                <v-card-text >
                        <v-layout wrap>
                            <v-flex xs12 class="headline mt-3" style="color: black;">
                                <v-text-field light v-model="username" autofocus="True" label="Username" type="text" required></v-text-field>
                                <v-text-field light v-model="password" label="Password" type="password" required v-on:keyup.enter="signin()" ></v-text-field>
                            </v-flex>
                        </v-layout>
                </v-card-text>

                <v-spacer></v-spacer>
                <v-btn absolute bottom right fab @click="signin()"><v-icon>done</v-icon></v-btn>

            </v-card>
        </v-layout>
    </v-container>



<!--    <v-form>-->
<!--        <v-container>-->
<!--                <v-text-field v-model="username" label="Username" required></v-text-field>-->
<!--                <v-flex xs12 sm6 md3><v-text-field label="Outline" outline></v-text-field></v-flex>-->



<!--            <v-text-field v-model="password" label="Password" required type="password"></v-text-field>-->
<!--                <v-btn @click="signin()">Sign-in</v-btn>-->
<!--        </v-container>-->
<!--    </v-form>-->
</template>

<script>

    import axios from 'axios';

    export default {
        data: () => ({
            username: '',
            password: '',
        }),
        props: {
        },
        methods: {
            signin() {
                axios.post('https://mf-homeauth.appspot.com/login', {
                    username: this.username,
                    password: this.password,
                    clientid: "wrpk5hda0ugt1cvmq1oempk6nnlxl2es3hyc"
                }).then(function (response) {
                        var d = new Date();
                        var exdays = 30;
                        d.setTime(d.getTime() + (exdays*24*60*60*1000));
                        var expires = "expires="+ d.toUTCString();
                        document.cookie = "tokenL7TFiZuzFO" + "=" + response.data.token + ";" + expires + ";path=/";
                }).then(() => {
                    this.$parent.$router.push('/home');
                })

            }
        }
    };
</script>

<style scoped>

    .input-boxx {
        color: #64dd17;
    }
</style>
